import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PageTitle from '../features/ui/util/page_title'
import BusinessLayout from '../layouts/business_layout'
import { me, meBusinesses } from '../initial_state'
import {
  LinkFooter,
  ProPanel,
  GabAdTopPanel,
  ProgressPanel,
} from '../features/ui/util/async_components'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import TabBar from '../components/tab_bar'
import { BREAKPOINT_EXTRA_SMALL, MODAL_PRO_UPGRADE, MODAL_UNAUTHORIZED } from '../constants'
import Button from '../components/button'
import List from '../components/list'
import Text from '../components/text'
// import BusinessFilterPanel from '../components/panel/business_filter_panel'
import BusinessCategoriesPanel from '../components/panel/business_categories_panel'
import { openModal } from '../actions/modal'

class BusinessCategoriesPage extends React.PureComponent {

  handleOnOpenModal = () => {
    this.props.dispatch(openModal(MODAL_UNAUTHORIZED))
  }

  handleOnOpenProModal = () => {
    this.props.dispatch(openModal(MODAL_PRO_UPGRADE, { isBusiness: true }))
  }

  render() {
    const { children, isXS } = this.props

    const sidebarLayout = [
      <WrappedBundle key='business-categories-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'business-categories.sidebar', position: 1 }} />,
      ProgressPanel,
      <WrappedBundle key='business-categories-page-pro-panel' component={ProPanel} />,
      LinkFooter,
    ].filter(Boolean)

    const tabs = [
      {
        title: 'Home',
        to: '/businesses',
        icon: 'home',
      },
      {
        title: 'Businesses',
        to: '/businesses',
        icon: 'ul-list',
      },
      !me && {
        title: 'Categories',
        to: '/businesses/categories',
        icon: 'ol-list',
        hideArrow: true,
        shouldHighlight: true,
        isActive: true,
      },
      !!me && !!meBusinesses && {
        title: 'My Businesses',
        to: '/businesses/dashboard',
        icon: 'apps',
      },
    ].filter(Boolean)

    const sidebarChildren = [
      <div key='mlcpcd-1' className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
        <List items={tabs} size='large' padded />
      </div>,
      (<div key='mlcpcd-2' className={[_s.d, _s.w100PC, _s.px5, _s.pt5].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to={!!me ? '/marketplace/create' : undefined}
          onClick={!me ? this.handleOnOpenModal : undefined}
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>Create Listing →</Text>
        </Button>
      </div>),
      (<div key='mlcpcd-3' className={[_s.d, _s.w100PC, _s.px5, _s.pt10].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to='/marketplace/business/join'
          backgroundColor='brandLight'
          color='brand'
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>List your Business →</Text>
        </Button>
      </div>),
      (<div key='mlcpcd-3' className={[_s.d, _s.w100PC, _s.px5, _s.pt10].join(' ')}>
        <Button
          isBlock
          isOutline
          radiusSmall
          backgroundColor='none'
          color='brand'
          onClick={this.handleOnOpenProModal}
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>Get GabPRO for Business</Text>
        </Button>
      </div>),
      // <BusinessFilterPanel key='mlcpcd-4' noPanel />,
      <BusinessCategoriesPanel key='mlcpcd-5' noPanel />,
    ]

    const xsTabs = !isXS ? undefined : [
      {
        title: 'Home',
        to: '/businesses',
      },
      {
        title: 'Categories',
        to: '/businesses/categories',
        active: true,
      },
      !!me && !!meBusinesses && {
        title: 'My Businesses',
        to: '/businesses/dashboard',
      },
    ].filter(Boolean)

    return (
      <BusinessLayout
        showBackBtn
        page='business'
        title='Business'
        sidebarChildren={sidebarChildren}
        layout={sidebarLayout}
      >
        <PageTitle path='Business' />

        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.h40PX, _s.z6, _s.top0, _s.right0, _s.left0, _s.posSticky, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
            <TabBar tabs={xsTabs} shouldGrow />
          </div>
        }

        {children}
      </BusinessLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

BusinessCategoriesPage.propTypes = {
  children: PropTypes.object,
}

export default connect(mapStateToProps)(BusinessCategoriesPage)
